import { orderTemplate } from '@/dataStructures';

export default {
	loading: false,
	orderTemplates: [],
	generatedOrders: [],
	templateDetails: orderTemplate()
};